import { type ReadonlyURLSearchParams } from 'next/navigation';

import { FILTER_KEY } from '@/ducks/filters/types';
import { getSearchParamsValue, toStringArray } from '@/ducks/filters/utils/primitive';
import { type TOptional } from '@/types/common';

import { DestinationType, type TSelectedRegionInfo } from '../types';

const extractSelectedRegionInfo = (
  searchParams: URLSearchParams | ReadonlyURLSearchParams,
): TOptional<TSelectedRegionInfo> => {
  const packagesIds = toStringArray(getSearchParamsValue(FILTER_KEY.destPackages, searchParams));
  const packagesRegionIds = toStringArray(getSearchParamsValue(FILTER_KEY.destPackagesRegions, searchParams));
  const portsIds = toStringArray(getSearchParamsValue(FILTER_KEY.destPorts, searchParams));
  const portsRegionIds = toStringArray(getSearchParamsValue(FILTER_KEY.destPortsRegions, searchParams));

  if (portsIds.length || portsRegionIds.length)
    return { destinationType: DestinationType.PORTS_OF_CALL, itemsIds: portsIds, regionsIds: portsRegionIds };
  if (packagesIds.length || packagesRegionIds.length)
    return { destinationType: DestinationType.ITINERARIES, itemsIds: packagesIds, regionsIds: packagesRegionIds };
};

export default extractSelectedRegionInfo;
